module.exports = __webpack_public_path__ + "img/ovulos o tabletas vaginales.ad4e0841.png";